import { render, staticRenderFns } from "./newBranch.vue?vue&type=template&id=51efc93c&scoped=true"
import script from "./newBranch.vue?vue&type=script&lang=js"
export * from "./newBranch.vue?vue&type=script&lang=js"
import style0 from "./newBranch.vue?vue&type=style&index=0&id=51efc93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51efc93c",
  null
  
)

export default component.exports